<div class="wrapper mt-2 mb-8">
  <div class="margins page-content">
    <slot />
  </div>
</div>
